import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { showModal } from 'appSrc/redux/actions';
import { Icon } from 'appSrc/components/UI';
import style from './styles/style.module.css';

class TheaterPlayIcon extends PureComponent {
    playMovie = ( e ) => {
        e.preventDefault();
        if( this.props.youtubeId ) {
            this.props.playMovie( this.props.youtubeId, this.props.metaData );
        }
    }
    render() {
        var className = `${ style.playIcon } ${ this.props.className }`.trim();
        return (
            <div className={ className } onClick={ this.playMovie } style={ this.props.style }>
                <Icon source='customSvg' icon='play-large'
                size={ this.props.size } />
            </div>
        );
    }
}
TheaterPlayIcon.defaultProps = {
    className: '',
    youtubeId : null,
    size: null,
    style: {},
};

const mapDispatchToProps = ( dispatch ) => {
    return {
        playMovie: ( youtubeId, metaData ) => {
            dispatch( showModal( 'movieTheater', { youtubeId: youtubeId, metaData: metaData } ) );
        },
    };
};

export default connect( null, mapDispatchToProps )( TheaterPlayIcon );
